module.exports = __webpack_public_path__ + "3ecb625b75ec64be437600e7a9f4ed47.svg";